/**
 * help-articles.ts
 *
 * Static help content for the in-app help panel.
 *
 * Phase 12 reset — the legacy RoofOps articles (jobs / quotes / invoicing /
 * client portal / accounting) were retired alongside the underlying features.
 * Fire-safety-specific articles (visits / certificates / FRAs) will be added
 * as their UIs ship.
 */

export interface HelpArticle {
  id: string;
  title: string;
  category: "getting-started" | "team" | "admin";
  summary: string;
  roles: Array<"admin" | "engineer">;
  content: HelpSection[];
}

export interface HelpSection {
  heading?: string;
  body: string;
}

export const HELP_CATEGORIES: Record<HelpArticle["category"], string> = {
  "getting-started": "Getting Started",
  team:              "Team",
  admin:             "Admin",
};

export const HELP_ARTICLES: HelpArticle[] = [
  {
    id: "welcome",
    title: "Welcome to FireSafetyOps",
    category: "getting-started",
    summary: "A short orientation to the app for new users.",
    roles: ["admin", "engineer"],
    content: [
      {
        body: "FireSafetyOps tracks your fire-safety customers, sites, and assets, schedules service visits, and produces compliance certificates. Use the sidebar to move between modules — admins see the full set, engineers see their visits.",
      },
      {
        heading: "Need more help?",
        body: "Use the Help & Feedback button at the bottom of the sidebar to send a question to your administrator.",
      },
    ],
  },
];
